import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/core/auth/auth.guard';
import { CanActivateChildGuard } from 'src/app/core/guards/can-activate-child.guard';
import { AddCategoryComponent } from './add-category/add-category.component';
import { ListCategoryComponent } from './list-category/list-category.component';

const routes: Routes = [
  {
    path: '',
    component: ListCategoryComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./list-category/list-category.module').then(m => m.ListCategoryModule),
  },
  {
    path: 'create',
    component: AddCategoryComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./add-category/add-category.module').then(m => m.AddCategoryModule),
  },
  {
    path: 'update/:id',
    component: AddCategoryComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./add-category/add-category.module').then(m => m.AddCategoryModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GeneralCategoryRoutingModule { }
